import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = (blocksNotLoaded) =>
  makeStyles(() =>
    createStyles({
      container: {
        flex: 1,
        flexGrow: 1,
        padding: 0,
        overflow: 'hidden',
        minHeight: blocksNotLoaded ? '100vh' : 'unset',
      },
    }),
  );
export default useStyles;
